import ViewPadrao from "../views/ViewPadrao";
import FornecedorList from "../views/FornecedorList";
import FornecedorCad from "../views/FornecedorCad";

export default {
  path: "fornecedor",
  component: ViewPadrao,
  children: [
    {
      path: "lista",
      name: "fornecedor-list",
      component: FornecedorList,
    },
    {
      path: "novo",
      name: "fornecedor-formulario",
      component: FornecedorCad,
    },
    {
      path: "editar/:id",
      name: "fornecedor-formulario-editar",
      component: FornecedorCad,
    },
  ],
};
